import axios from "axios";

import { getUserCredentials } from "../utils/common";
import { API_URL_AUTH, API_URL } from "../utils/Constant";

/**
 * Build logout URL based on available API URLs
 * @returns {string} Logout endpoint URL
 */
const buildLogoutUrl = () => {
  if (API_URL_AUTH) return `${API_URL_AUTH}/logout/`;
  if (API_URL) return `${API_URL}/logout/`;
  return "/logout/";
};

/**
 * Logout function that calls backend /logout/ API
 * Invalidates the Firebase token on the backend
 * @returns {Promise<Object>} { success: boolean, message?: string }
 */
const logout = async () => {
  const userCredentials = getUserCredentials();

  const {
    company_domain,
    user_email,
    firebase_id_token,
    firebase_refresh_token,
  } = userCredentials || {};

  // Validate required credentials
  if (!company_domain || !user_email || !firebase_id_token) {
    return {
      success: false,
      message: "Missing user credentials required to logout.",
    };
  }

  const refreshTokenValue = firebase_refresh_token;

  const payload = {
    company_domain,
    user_email,
    firebase_id_token,
    disableInterceptor: true, // Prevents automatic retry on failure
  };

  if (refreshTokenValue) {
    payload.firebase_refresh_token = refreshTokenValue;
  }

  try {
    const response = await axios.post(buildLogoutUrl(), payload);
    return {
      success: response.data?.message === "Success" || true,
      message: response.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message ?? error.message ?? "Logout failed",
    };
  }
};

export default logout;
